import React, { useEffect, useRef } from "react";
import { Modal, Button } from "antd";
import styles from './CongratsModal.module.css'
import congratsAnimation from "./congrats-animation.json";

export default function CongratsModal({
    open,
    onOk,
    onCancel,
}) {
    const containerRef = useRef(null);

    useEffect(() => {
        let animation;

        const script = document.createElement("script");
        script.src =
            "https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js";

        script.onload = () => {
            animation = window.lottie.loadAnimation({
                container: containerRef.current,
                renderer: "svg",
                loop: false,
                autoplay: true,
                animationData: congratsAnimation,
            });
        };

        document.body.appendChild(script);

        return () => {
            if (animation) animation.destroy();
            document.body.removeChild(script);
        };
    }, []);

    return (
        <Modal
            open={open}
            footer={null}
            centered
            width={420}
            closable={false}
            maskClosable={false}
            wrapClassName={styles.blurredModal}
            maskStyle={{
                backdropFilter: "blur(10px)",
                backgroundColor: "rgba(0,0,0,0.4)",
            }}
            modalRender={(node) => (
                <div
                    style={{
                        borderRadius: 16,
                        overflow: "hidden",
                        boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
                    }}
                >
                    {node}
                </div>
            )}
        >
            <div style={{ textAlign: "center", padding: 12 }}>
                <div
                    ref={containerRef}
                    style={{
                        width: 140,
                        height: 250,
                        margin: "0 auto",
                    }}
                />

                <p className={styles.congratsHeading}>Congratulations!</p>
                <p className={styles.congratsText}>
                    You have successfully completed onboarding
                </p>
                <p className={styles.congratsText}>
                    Explore talent tailored to your needs and start
                </p>
                <p className={styles.congratsText}>building your team.</p>

                <button
                    type="primary"
                    block
                    onClick={onOk}
                    className={styles.dashboardButton}
                >
                    Get Started
                </button>
            </div>
        </Modal>
    );
}